// extracted by mini-css-extract-plugin
module.exports = {"button":"systemInformation_button__RH-r3","text":"systemInformation_text__1QlFl","allocated":"systemInformation_allocated__2WLkL"};